import Modal from './src/modal.vue'
import $Modal from './modalConfirm'

Modal.$Modal = $Modal;

export default Modal
